// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionK_comp__tJ0Cj"};